'use client';
import { useState, useEffect, useRef } from 'react';

export default function MyChat() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [open, setOpen] = useState(false);
  const bottomRef = useRef();

  // Add default message when chat opens
  useEffect(() => {
    if (open && messages.length === 0) {
      setMessages([
        {
          role: 'assistant',
          content: `Hello! How can I help you with your home remodeling today?\nYou can request a free estimate by calling us at <a href="tel:13233004130" style="text-decoration: underline; color: #aa8453;">323-300-4130</a> or visit: <a href="https://modernbuildremodel.com/contact" target="_blank" rel="noopener noreferrer" style="text-decoration: underline; color: #aa8453;">Our Contact Page</a>`
        },
      ]);
    }
  }, [open]);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { role: 'user', content: input };
    setMessages(prev => [...prev, userMessage]);
    setInput('');

    try {
      const res = await fetch('/api/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: [...messages, userMessage] }),
      });

      const data = await res.json();
      const botMessage = { role: 'assistant', content: data.reply };
      setMessages(prev => [...prev, botMessage]);
    } catch (err) {
      console.error('Chat error:', err);
    }
  };

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div style={{ position: 'fixed', bottom: 10, right: 0, width: 66, zIndex: 999 }}>
      <button
        onClick={() => setOpen(!open)}
        style={{
          background: '#aa8453',
          color: '#fff',
          border: 'none',
          borderRadius: '50%',
          width: 60,
          height: 60,
          cursor: 'pointer',
          fontSize: 14,
          boxShadow: '0 5px 10px rgba(0, 0, 0, 0.25)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        }}
      >
        Let’s chat
      </button>

      {open && (
        <div
          style={{
            position: 'absolute',
            bottom: 70,
            right: 10,
            width: 300,
            background: '#fff',
            borderRadius: 10,
            display: 'flex',
            flexDirection: 'column',
            height: 400,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          }}
        >
          {/* Close button */}
          <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 5 }}>
            <button
              onClick={() => setOpen(false)}
              style={{
                background: 'transparent',
                border: 'none',
                fontSize: 20,
                cursor: 'pointer',
                marginRight: 10,
              }}
            >
              ✖
            </button>
          </div>

          {/* Messages */}
          <div style={{ flex: 1, overflowY: 'auto', padding: 10 }}>
            {messages.map((msg, i) => (
              <div key={i} style={{ marginBottom: 10 }}>
                <strong>{msg.role === 'user' ? 'You: ' : 'Modern Build: '}</strong>
                <div
                  dangerouslySetInnerHTML={{ __html: msg.content.replace(/\n/g, '<br/>') }}
                />
                <div
                  style={{
                    borderBottom: '1px dashed rgba(217,217,217,1)',
                    width: '100%',
                    margin: '5px 0'
                  }}
                ></div>
              </div>
            ))}
            <div ref={bottomRef} />
          </div>

          {/* Input area */}
          <div style={{ display: 'flex', borderTop: '1px solid #ccc' }}>
            <input
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && sendMessage()}
              placeholder="Type a message..."
              style={{ flex: 1, padding: 8, border: 'none', outline: 'none' }}
            />
            <button
              onClick={sendMessage}
              style={{
                background: '#aa8453',
                color: '#fff',
                border: 'none',
                padding: '0 16px',
                cursor: 'pointer',
              }}
            >
              Send
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
